import React, { Component } from 'react'
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup, Button } from 'react-bootstrap';

import { Http } from '../../../../support';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import PopConfirm from '../../../../facturotopia/popconfirm/PopConfirm';

class ComprobantesItemActions extends Component {

  state = {
    showConfirm: false
  }

  handleOnCancelActionClick = () => {
    this.setState({
      showConfirm: true
    });
  }

  handleOnDownloadActionClick = async (kind) => {
    const { selectedRows } = this.props;

    this.setState({
      busy: true
    });

    try {
      const uuids = selectedRows.map((item) => item.uuid);

      const body = {
        type: kind || 'pdf',
        uuids
      }

      const response = await Http.post(`${window.BONJOUR_URL}/api/comprobantes/download`, body, { responseType: 'blob' });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar tus comprobantes'
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  handleOnAction = (action) => {

  }

  render() {
    const { showConfirm, busy } = this.state;
    const { alignRight } = this.props;

    if (!!busy) {
      return (
        <LoadingButton type="button"
          variant="transparent"
          loading={ busy }
        >
          Descargando
        </LoadingButton>
      );
    }

    return (
      <>
        { showConfirm &&
          (
            <PopConfirm variant="inline" text="Realmente deseas cancelar?"
              onAction={ this.handleOnAction }
            />
          )
        }

        { !showConfirm &&
          (
            <Dropdown as={ ButtonGroup } alignRight={ alignRight }>
              { Guardian.allows('factura.descarga.masiva.pdf') && Guardian.allows('factura.descarga.masiva.xml') && (
                <Button variant="secondary"
                  onClick={ this.handleOnDownloadActionClick.bind(this, 'zip') }
                >
                  Descargar
                </Button>
              )}

              <Dropdown.Toggle split variant="secondary" id="dropdown-split-basic" />

              <Dropdown.Menu>
                { Guardian.allows('factura.descarga.masiva.xml') && (
                  <Dropdown.Item as="div" onClick={ this.handleOnDownloadActionClick.bind(this, 'xml') }>Descargar XMLs</Dropdown.Item>
                )}

                { Guardian.allows('factura.descarga.masiva.pdf') && (
                  <Dropdown.Item as="div" onClick={ this.handleOnDownloadActionClick.bind(this, 'pdf') }>Descargar PDFs</Dropdown.Item>
                )}
                <Dropdown.Divider />
                {/* <Dropdown.Item as="div" onClick={ this.handleOnCancelActionClick }>Cancelar</Dropdown.Item> */}
                {/* <Dropdown.Item href="#/action-2">Enviar por email</Dropdown.Item> */}
              </Dropdown.Menu>
            </Dropdown>
          )
        }
      </>

    )
  }
}

export default ComprobantesItemActions;